import { http } from './http';

export const getExperiment = id => http.get(`experiment/${id}`);

export const getExperiments = () =>
  http.get(`experiment/?visibility=0&type=0&sort=recent`);
